require('writing/questions/sentence_starter_text_area.scss');
var SpeechControls = require("components/writing/questions/SpeechControls");


class SentenceStarterTextArea extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.textarea = React.createRef();
		this.starterDisplay = React.createRef();

		this.state = { starterWidth: 0, starterYOffset: 1, textAreaHeight: undefined }
	}

	focus() {
		this.textarea.current.focus();
	}

	onChange(e) {
		this.props.onChange(e.target.value);
		setTimeout(this.updateTextAreaHeight, 10);
	}
	setText(text) {
		this.props.onChange(text);
		setTimeout(this.updateTextAreaHeight, 10);
	}
	lineHeight() {
		// Works as long as line-heigh is in px...
		if (this.starterDisplay.current) {
			return parseFloat($(this.starterDisplay.current).css("line-height"));

		} else {
			return 22;
		}
	}

	width() {
		if (this.textarea.current) {
			return $(this.textarea.current).width();
		} else {
			return 487;
		}
	}
	getAnswer() {
		return this.textarea.current.value
	}
	getTextToRead() {
		return this.props.starterText
	}
	renderSpeechControls() {
		return (
			<div className="voiceFirstSpeechControls">
				<SpeechControls getText={ this.getAnswer } setText={ this.setText }
					getTextToRead={ this.getTextToRead } toggleHighlight={ this.toggleHighlight }
					autoReadText={ false } />
			</div>
		);
	}

	render() {
		var lineHeight = this.lineHeight();
		var yOffset = this.state.starterYOffset;
		var trueYOffest = yOffset;
		var textIndent = this.state.starterWidth + 10;

		if (textIndent > (this.width() * 0.8)) {
			// If text indent is more than 80% of the width, word breaks
			// for the first word might be rough. Push to next line.
			var yOffset = yOffset + lineHeight;
			var textIndent = 0;
		}

		var starterLines = Math.round(trueYOffest / lineHeight);

		var textAreaProps = _.omit(this.props, 
			"starterText", "onChange", "rows", "handlePasteBehaviour", "speechControlSetting");
		textAreaProps.className = textAreaProps.className || "form-control";

		textAreaProps.style = textAreaProps.style || {};

		if (this.state.textAreaHeight) {
			textAreaProps.style.height = this.state.textAreaHeight;

		} else if (this.props.rows) {
			textAreaProps.rows = parseInt(this.props.rows || "3");
			textAreaProps.rows += starterLines - 1;

		}

		var paddingTop = (yOffset - lineHeight) + 7;

		textAreaProps.style.textIndent = textIndent;
		textAreaProps.style.paddingTop = paddingTop;

		var starterStyle = {}

		var leftLine = (
			<div className="lineFix" style={{ left: 0, top: trueYOffest }} />
		);
		if (starterLines > 1) {
			// We only need to add a line on the right if it wraps around at least once
			var rightLine = (
				<div className="lineFix rightFix"
					style={{ right: 0, top: (trueYOffest - this.lineHeight()) }} />
			);
		} else {
			// Makes border go up to top of text area. Normally this is 3.
			starterStyle.paddingTop = 7;
		}

		// NOTE: "end" needs contenct, or it doesn't hold its position
		// We make it opacity and width 0 in CSS

		return (
			<div className="sentenceStarterTextArea">
				{ leftLine }{ rightLine }
				<div className="starterWrap">
					<span className="starter" style={ starterStyle } ref={ this.starterDisplay }>
						{ this.props.starterText }
						<span className="end">.</span>
					</span>
				</div>
				<textarea { ...textAreaProps } ref={ this.textarea } onChange={ this.onChange } onPaste={this.props.handlePasteBehaviour} />
				{ this.renderSpeechControls() }
			</div>
		);
	}

	updateStarterDisplay() {
		var $starter = $(this.starterDisplay.current);

		// Lots of credit @Nelson https://stackoverflow.com/a/22266818/4557470
		var starterWidth = $starter.find(".end").position().left;

		// This is a little hacky, and might break easily on different browsers...
		var starterYOffset = $starter.parents(".starterWrap").height();

		// Check if it's more than 75% of the width and if we haven't shrunk it too much yet
		this.setState({
			starterWidth: starterWidth, starterYOffset: starterYOffset
		}, this.updateTextAreaHeight);
	}

	updateTextAreaHeight() {
		// For some reason, this.textarea.current sometimes becomes undefined
		// even if we check first...
		var scrollHeight = (this.textarea.current || {}).scrollHeight;
		var clientHeight = (this.textarea.current || {}).clientHeight;

		if (scrollHeight === undefined || clientHeight === undefined) {
			return;
		}

		if (scrollHeight > clientHeight) {
			var effectiveHeight = Math.min(scrollHeight + 2, 250)
			this.setState({ textAreaHeight: effectiveHeight });
		}
	}

	componentDidMount() {
		this.updateStarterDisplay();			

	}
}


SentenceStarterTextArea.propTypes = StrictPropTypes({
	starterText: PropTypes.string,
	onChange: PropTypes.func,
	handlePasteBehaviour: PropTypes.func,

	// To pass on to NormalTextArea
	className: PropTypes.string,
	placeholder: PropTypes.string,
	rows: PropTypes.string,
	value: PropTypes.string,
	speechControlSetting: PropTypes.string
});

module.exports = SentenceStarterTextArea;



// WEBPACK FOOTER //
// ./modules/components/writing/questions/SentenceStarterTextArea.js